import { LANGUAGE } from "@/common/utils/constants.js";

export const PICTURES_PPT = {
	[LANGUAGE.en.short]: {
		title1: `Project Cover Image`,
		title2: `Project Image Gallery`
	},
	[LANGUAGE.de.short]: {
		title1: `Titelbild des Projekts`,
		title2: `Projekt-Bildergalerie`
	},
	[LANGUAGE.fr.short]: {
		title1: `Image de couverture du projet`,
		title2: `Galerie d'images du projet`
	},
	[LANGUAGE.it.short]: {
		title1: `Immagine di copertina del progetto`,
		title2: `Galleria immagini del progetto`
	},
	[LANGUAGE.ja.short]: {
		title1: `プロジェクトのカバー画像`,
		title2: `プロジェクトイメージギャラリー`
	},
	[LANGUAGE.es.short]: {
		title1: `Imagen de portada del proyecto`,
		title2: `Galería de imágenes del proyecto`
	},
}
